import { render, staticRenderFns } from "./CreateVoteModal.vue?vue&type=template&id=8cee8a5a&"
import script from "./CreateVoteModal.vue?vue&type=script&lang=js&"
export * from "./CreateVoteModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateVoteModal.vue?vue&type=style&index=0&id=8cee8a5a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports